import { render, staticRenderFns } from "./BatchUploadModal.vue?vue&type=template&id=4ef85888&"
import script from "./BatchUploadModal.vue?vue&type=script&lang=js&"
export * from "./BatchUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchUploadModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports